<template>
    <v-wait for="loading data" class="layout column fill-height waitfor-container">
        <template slot="waiting">
            <v-calendar :value="current" class="loading">
                <template v-slot:day="{ day }">
                    <vcl-facebook v-if="day % 3 == 0"></vcl-facebook>
                </template>
            </v-calendar>
        </template>
        <v-row v-if="hasSelectedGarage()">
            <v-col cols="12" md="10" class="pa-0">
                <v-container fill-height>
                    <v-calendar ref="calendar" :value="current" color="primary" @click:date="goToDay($event.date)" @click:day="goToDay($event.date)">
                        <template v-slot:day="{ date }">
                            <v-flex v-ripple fill-height>
                                <template v-if="events[date]">
                                    <div class="mx-2" v-if="events[date][preventativeMaintenance]">{{ events[date][preventativeMaintenance].length }} x {{ preventativeMaintenance }}</div>
                                    <div class="mx-2" v-if="events[date][majorService]">{{ events[date][majorService].length }} x {{ majorService }}</div>
                                    <div class="mx-2" v-if="events[date][defect]">{{ events[date][defect].length }} x {{ defect }}</div>
                                    <div class="mx-2" v-if="events[date][completedDefect]">{{ events[date][completedDefect][0] }} x {{ completedDefect }}</div>
                                    <div class="mx-2" v-if="events[date][dateBasedTask]">{{ events[date][dateBasedTask].length }} x {{ dateBasedTask }}</div>
                                    <div class="mx-2" v-if="events[date][brakeCheck]">{{ events[date][brakeCheck].length }} x {{ brakeCheck }}</div>
                                    <div class="mx-2" v-if="events[date][campaign]">{{ events[date][campaign].length }} x {{ campaign }}</div>
                                    <div class="mx-2" v-if="events[date][containerInspection]">{{ events[date][containerInspection].length }} x {{ containerInspection }}</div>
                                </template>
                            </v-flex>
                        </template>
                    </v-calendar>
                </v-container>
            </v-col>
            <v-col cols="4" md="2" class="px-0 py-5">
                <units-summary :from="from" :to="to" period="month"></units-summary>
            </v-col>
        </v-row>
        <v-alert v-else type="warning" class="ma-5">You have not selected a Garage Location</v-alert>
    </v-wait>
</template>

<script>
import { VclFacebook } from 'vue-content-loading';
import Controls from './MonthControls.vue';
import Services from '@/components/Services/ServicesClient.vue';
import DefectNotices from '@/components/DefectNotices/DefectNoticesClient.vue';
import DateBasedTasks from '@/components/DateBasedTasks/DateBasedTasksClient.vue';
import GarageLocations from '@/components/GarageLocations/GarageLocationsClient.vue';
import BrakeChecks from '@/components/BrakeChecks/BrakeCheckClient.vue';
import Campaigns from '@/components/Campaigns/CampaignClient.vue';
import UnitsSummary from '@/components/GarageLocations/UnitsSummary';
import CalendarHelper from '@/lib/CalendarHelper';
import { MonthEventType } from '@/models/enums';
import * as _ from 'lodash';
import Calendar from '@/views/Calendar';

export default {
    mixins: [Controls, Services, DefectNotices, DateBasedTasks, GarageLocations, BrakeChecks, Campaigns],
    components: {
        VclFacebook,
        UnitsSummary
    },
    computed: {
        events() {
            const map = {};
            this.services.filter(s => s.garageLocationId === this.userGarage).forEach(e => CalendarHelper.mapService(e, map));
            this.defects.forEach(e => CalendarHelper.mapDefect(e, map));
            this.dateBasedTasks.filter(s => s.garageLocationId === this.userGarage).forEach(e => CalendarHelper.mapDateBasedTask(e, map));
            this.brakeChecks.forEach(e => CalendarHelper.mapBrakeCheck(e, map));
            this.campaigns.forEach(e => CalendarHelper.mapCampaign(e, map));
            this.completedDefects.forEach(e => CalendarHelper.mapCompletedDefect(e, map));
            return map;
        }
    },
    methods: {
        async getEvents() {
            if (!this.current || !this.userGarage) {
                return;
            }

            this.$wait.start('loading data');
            const servicesAwaiter = this.getServices();
            const defectsAwaiter = this.getDefects();
            const campaignsAwaiter = this.getCampaignUnits();
            const completedDefectsAwaiter = this.getCompletedDefectCounts();
            const brakesAwaiter = this.getBrakeChecks(this.userGarage, this.from, this.to);
            const tasksAwaiter = this.getDateBasedTasks();

            this.services = await servicesAwaiter;
            const defects = await defectsAwaiter;
            this.campaigns = await campaignsAwaiter;
            this.completedDefects = await completedDefectsAwaiter;
            this.brakeChecks = await brakesAwaiter;
            const tasks = await tasksAwaiter;

            this.defects = defects.filter(d => !d.isComplete);
            this.dateBasedTasks = tasks.filter(t => !t.isDeleted);
            this.$wait.end('loading data');
        }
    },
    async mounted() {
        await this.getEvents();
        await this.loadUserGarages();
    },
    watch: {
        async current(val) {
            await this.getEvents();
        },
        async userGarage(val) {
            await this.getEvents();
        }
    },
    data() {
        return {
            services: [],
            dateBasedTasks: [],
            defects: [],
            brakeChecks: [],
            campaigns: [],
            completedDefects: [],
            preventativeMaintenance: MonthEventType.PreventativeMaintenance,
            majorService: MonthEventType.MajorService,
            defect: MonthEventType.Defect,
            dateBasedTask: MonthEventType.DateBasedTask,
            brakeCheck: MonthEventType.BrakeCheck,
            campaign: MonthEventType.Campaign,
            completedDefect: MonthEventType.CompletedDefects,
            containerInspection: MonthEventType.ContainerInspection
        };
    }
};
</script>

<style lang="scss">
.loading {
    .v-calendar-weekly__head-weekday,
    .v-calendar-weekly__day-label,
    .v-calendar-weekly__day-month {
        display: none;
    }

    .v-calendar-weekly__day {
        padding: 4px;
    }
}

.waitfor-container > span {
    display: flex;
    flex: 1;
}

.v-calendar-weekly__day {
    cursor: pointer;
}

.v-calendar-weekly__day:hover {
    //elevation-12
    box-shadow: 0px 3px 1px -2px rgba(0, 0, 0, 0.2), 0px 2px 2px 0px rgba(0, 0, 0, 0.14), 0px 1px 5px 0px rgba(0, 0, 0, 0.12) !important;
}
.v-calendar-weekly__week {
    height: unset;
}
</style>
